import { X } from "lucide-react";
import { useEffect, useRef } from "react";
import type {
  TeachingSectionName,
  TeachingUnitRecord,
} from "../data/buildGraphData";
import { teachingTabs } from "./NodeDetail";

type ReaderDialogProps = {
  unit: TeachingUnitRecord;
  initialSection: TeachingSectionName;
  onClose: () => void;
};

export function ReaderDialog({ unit, initialSection, onClose }: ReaderDialogProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    dialog?.showModal();
    const onCancel = (event: Event) => {
      event.preventDefault();
      onClose();
    };
    dialog?.addEventListener("cancel", onCancel);
    return () => dialog?.removeEventListener("cancel", onCancel);
  }, [onClose]);

  return (
    <dialog ref={dialogRef} className="reader-dialog" onClose={onClose}>
      <header>
        <div>
          <span>N{String(unit.number).padStart(3, "0")}</span>
          <h2>{unit.title}</h2>
        </div>
        <button type="button" onClick={onClose} aria-label="关闭阅读模式" title="关闭">
          <X size={20} aria-hidden="true" />
        </button>
      </header>
      <article>
        {teachingTabs.map((section) => (
          <section key={section} id={`reader-${section}`} data-initial={section === initialSection}>
            <h3>{section}</h3>
            {unit.sections[section].map((paragraph, index) => (
              <p key={`${section}-${index}`}>{paragraph}</p>
            ))}
          </section>
        ))}
      </article>
    </dialog>
  );
}
